import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    cloneDeep as _cloneDeep,
} from 'lodash';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import Auth from '../../../../data/auth-service';
import DataContext from '../../../../data/data-context';

const useStyles = makeStyles(theme => ({
    roleButton: {
        float: 'right',
        marginLeft: theme.spacing(2),
    },
}));

const AuthNone = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { systemSettings, updateSystemSettings } = useContext(DataContext);
    const [current, setCurrent] = useState({});
    const externalPerms = Auth.permissions.get('AuthenticationExternal');

    useEffect(() => {
        if (systemSettings && Object.prototype.hasOwnProperty.call(systemSettings, 'auth')) {
            const s = _cloneDeep(systemSettings);

            s.auth.okta.enabled = false;
            s.auth.saml.enabled = false;
            s.auth.ldap.disabled = true;

            setCurrent(s);
        }
    }, [systemSettings]);

    const handleCancel = () => {
        setCurrent(_cloneDeep(systemSettings));
        navigate('/system/configuration');
    };

    const handleSave = () => {
        updateSystemSettings({ auth: current.auth });
    };

    return (
        <Grid container spacing={6}>
            <Grid container item xs={12} spacing={2}>
                {externalPerms.write && <Grid item xs={12}>
                    <Button
                        className={classes.roleButton}
                        variant="contained"
                        color="primary"
                        aria-label="save"
                        onClick={handleSave}
                        disabled={!externalPerms.write}>
                        Save
                    </Button>
                    <Button
                        className={classes.roleButton}
                        variant="contained"
                        color="secondary"
                        aria-label="cancel"
                        onClick={handleCancel}
                        // disabled={!changes}
                    >
                        Cancel
                    </Button>
                </Grid>}
            </Grid>
        </Grid>
    );
};

export default AuthNone;
